import type { NextPage, GetStaticPaths, InferGetStaticPropsType } from 'next';
import React from 'react';
import { makeStaticProps } from 'src/utils/props/makeStaticProps';
import { getGenericData } from 'src/common/api/getGenericData';
import { toSiteCorePath } from 'src/common/pathConvert';
import { getDefaultPage } from 'src/common/api/getDefaultPage';
import WATracker from '@components/WATracks';
import { AppContent, FrontendPageComponentValue, pageMapping } from '@src/common/pageMapping';
import { makeServerSideProps } from '@src/utils/props/makeServerSideProps';
import { InferGetServerSidePropsType } from 'next/types';

const GenericPage: NextPage = (props: InferGetServerSidePropsType<typeof getServerSideProps>) => {
    const PageContentComponent =
        pageMapping[props.frontendPageComponent as FrontendPageComponentValue]?.component;
    let PageContent = null;
    if (PageContentComponent) {
        PageContent = <PageContentComponent {...props}></PageContentComponent>;
    } else {
        PageContent = <AppContent {...props}></AppContent>;
    }

    return (
        <>
            <WATracker />
            {PageContent}
        </>
    );
};

export const getServerSideProps = makeServerSideProps(async (ctx) => {
    const paths = ctx.params?.genericPath as string[];
    let genericData = await getGenericData(paths, ctx.locale);
    if (!genericData.pageData) {
        if (!paths || paths.length <= 2) {
            const path = toSiteCorePath(paths);
            const defautPath = await getDefaultPage(path, ctx.locale);
            if (defautPath) {
                return {
                    redirect: {
                        destination: defautPath,
                        permanent: false,
                    },
                };
            } else {
                return {
                    notFound: true,
                };
            }
        } else {
            return {
                notFound: true,
            };
        }
    }
    return {
        props: genericData,
    };
});

export default GenericPage;
